import * as c from 'common/c'
import update from 'immutability-helper'

declare module 'state/ads.js' {
  export type AdModel = {
    id: number
    hardwareTypeId?: number
    hardwareType?: string
    deviceType?: number
    productName: string
    productVersion?: string
    productBenefits: string[]
    bannerImageUrl: string
    storeUrl?: string
    isActive: boolean
    minVersion?: string
    maxVersion?: string
    targetNonOwners: boolean
    displayOrder: number
    createdAt: string
    updatedAt: string
  }
  export type Ads = {
    collection: AdModel[]
    status: 'idle' | 'loading' | 'error'
  }
}

const initialState: Ads = { collection: [], status: 'idle' }

export default (state = initialState, action: any): Ads => {
  switch (action.type) {
    case c.ADS_LOADING: {
      return update(state, { status: { $set: 'loading' } })
    }
    case c.ADS_FETCHED: {
      return update(state, {
        collection: { $set: action.payload },
        status: { $set: 'idle' },
      })
    }
    case c.ADS_ERROR: {
      return update(state, { status: { $set: 'error' } })
    }
    default:
      return state
  }
}
